
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

// > services/types <
import { WaybillForwarder } from '@/modern/modules/m-dispatcher-module/services/types/waybill.types'

export default defineComponent({
    props: {
        forwarder: {
            type: [Object, null] as PropType<WaybillForwarder | null>,
            default: null
        },
    }
})
